import { css, keyframes } from 'styled-components';
var slideIn = keyframes(["0%{opacity:0;transform:translateY(-100%);}100%{opacity:1;transform:translateY(0);}"]);
export var slideInRule = css(["", " 0.25s ease;"], slideIn);